<template>
  <div class="footer">
    <div class="footer-area">
      <img class="m-4 footer-image" width="150" height="150" alt="Diablo II: Resurrected" src="../assets/D2TZ-logo.png">
      <div>
        <div class="footer-row">
          <div class="inline-block">
            <b>Community</b>
            <b-link aria-label="Discord Community" href="https://discord.gg/jzazZGwc2J" target="_blank">Discord Community</b-link>
          </div>
          <div class="inline-block">
            <b>About</b>
            <b-link aria-label="About us" href="/about" target="_blank">About Us</b-link>
          </div>
        </div>
        <div class="footer-row">
          <div class="inline-block">
            <b>Feedback</b>
            <b-link aria-label="Contact Us" @click="open('contact-us-modal')">Contact Us</b-link>
          </div>
          <div class="inline-block">
            <b> Email </b>
            <a href="mailto:support@d2tz.info">support@d2tz.info</a>
          </div>
        </div>
        <div class="footer-row">
          <b>Policies</b>
          <b-link aria-label="Terms of Service" href="/terms">Terms of Service</b-link>
          <b-link aria-label="Privacy Policies" href="/privacy">Privacy Policies</b-link>
        </div>
        <div class="footer-row">
          <b>2023-2025 D2TZ Team All Right Reserved</b>
        </div>
      </div>
    </div>
    <contact-us-modal ref="contact-us-modal" @success="showSuccessContactUs"/>
    <report-error-modal ref="report-error-modal" @success="showSuccessReportError"/>
    <report-next-terror-zone-modal ref="report-next-tz-modal" @success="showSuccessReportNextTZ"/>
    <b-modal
      v-model="showMsgModal"
      :title="msgTitle"
      header-bg-variant="dark"
      header-text-variant="light"
      body-bg-variant="dark"
      body-text-variant="light"
      footer-bg-variant="dark"
      footer-text-variant="light"
      hideHeaderClose
      ok-only
    >
      <p class="my-2">{{ msgContent }}</p>
    </b-modal>
    <b-modal
      v-model="showInstallAppModal"
      title="D2TZ Discord App"
      hideHeaderClose
      ok-only
    >
      <b-card no-body>
        <b-tabs content-class="mt-3" card>
          <b-tab :title="$t('footer.installText')" active>
            <InstallApp/>
          </b-tab>
          <b-tab :title="$t('footer.useText')">
            <UseApp/>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import ContactUsModal from './modals/ContactUs.vue'
import ReportErrorModal from './modals/ReportError.vue'
import ReportNextTerrorZoneModal from './modals/ReportNextTZ.vue'
import InstallApp from './apps/InstallApp.vue'
import UseApp from './apps/UseApp.vue'

export default {
  name: 'TerrorZoneFooter',
  data() {
    return {
      showMsgModal: false,
      showInstallAppModal: false,
      msgTitle: "",
      msgContent: "",
    }
  },

  components: {
    ContactUsModal,
    ReportErrorModal,
    ReportNextTerrorZoneModal,
    InstallApp,
    UseApp,
  },

  methods: {
    open (id) {
      this.$refs[id].show();
    },

    showSuccessContactUs () {
      const title = 'Request sent';
      const msg = "Thanks for contacting us! We'll touch with you later.";
      this.showMessage(title, msg);
    },

    showSuccessReportError () {
      const title = 'Report sent';
      const msg = "Thanks for reporting error! We'll handle it later.";
      this.showMessage(title, msg);
    },

    showSuccessReportNextTZ () {
      const title = 'Report sent';
      const msg = "Thanks for reporting the next terror zone!";
      this.showMessage(title, msg);
    },

    showToast (title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        variant: 'success',
      });
    },

    showMessage (title, message) {
      this.msgTitle = title;
      this.msgContent = message;
      this.showMsgModal = true;
    },

    showInstallGuide () {
      this.showInstallAppModal = true;
    }
  },
}
</script>

<style scoped>
.inline-block {
  display: inline-block;
}
.footer {
  background-color: #202224;
  height: 230px;
  color: #fff;
  padding: 20px 0px;
}
.footer-area {
  display: flex;
  justify-content: space-around;
  width: 80%;
  max-width: 750px;
  margin: auto;
}
.footer-row {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.footer-row b {
  padding: 0px 5px;
}
.footer-row a {
  padding-right: 5px;
  color: #e4e6eb;
}
.footer-image {
  display: block;
}
@media (max-width: 900px) {
  .footer-image {
    display: none;
  }
  .footer-area {
    width: 100%;
  }
}
</style>
